import { render, staticRenderFns } from "./ApprovalTarget.vue?vue&type=template&id=33939818"
import script from "./ApprovalTarget.vue?vue&type=script&lang=js"
export * from "./ApprovalTarget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports